import angular from 'angular';
import { Registration } from '../model/registration';

angular
  .module('cxRegistrations')
  .factory('regDialogsSvc', ['$q', 'ModalService', '$timeout', regDialogsSvc]);

function regDialogsSvc($q, ModalService, $timeout) {
  function showModal(modalOptions) {
    var deferred = $q.defer();
    ModalService.showModal(modalOptions).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) deferred.resolve(result);
        else deferred.reject(null);
      }, deferred.reject);

      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
        $timeout(() => {
          deferred.reject(null);
        }, 1000);
      });
    });
    return deferred.promise;
  }

  function showEditGroupDialog(registration) {
    return showModal({
      template: require('./regEditGroupDialog.html'),
      controller: 'RegEditGroupDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        registration: registration,
      },
    });
  }

  function showEditDialog(registration, settings) {
    return showModal({
      template: require('./registrationEditDialog.html'),
      controller: 'RegistrationEditDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        registration: registration,
        settings: settings,
      },
    });
  }
  function showAbsenceDialog(registration, settings) {
    return showModal({
      template: require('./absenceDialog.html'),
      controller: 'AbsenceDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        registration: registration,
        settings: settings,
      },
    });
  }

  function showTrainingDialog(registration, settings) {
    return showModal({
      template: require('./trainingDialog.html'),
      controller: 'TrainingDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        registration: registration,
        settings: settings,
      },
    });
  }

  return {
    newRegistrationGroup: function(relations) {
      return showEditGroupDialog(null, relations);
    },
    editRegistrationGroup: function(registration) {
      return showEditGroupDialog(registration);
    },
    newRegistration: function(settings) {
      return showEditDialog(null, settings);
    },
    editRegistration: function(registration, settings) {
      return showEditDialog(registration, settings);
    },
    newCategory: function() {
      return showModal({
        template: require('./newCategoryDialog.html'),
        controller: 'NewCategoryDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
      });
    },
    newSubResource: function(category) {
      return showModal({
        template: require('./newSubResourceDialog.html'),
        controller: 'NewSubResourceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          category: category,
        },
      });
    },
    newAbsence: function(registration, settings) {
      return showAbsenceDialog(registration, settings);
    },
    editAbsence: function(registration, settings) {
      return showAbsenceDialog(registration, settings);
    },
    newTraining: function(registration, settings) {
      return showTrainingDialog(registration, settings);
    },
    editTraining: function(registration, settings) {
      return showTrainingDialog(registration, settings);
    },
    batchUpdateField: function(filters, batchParams) {
      return showModal({
        template: require('./batchUpdateRegistrationFieldDialog.html'),
        controller: 'BatchUpdateRegistrationFieldDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          filters,
          batchParams,
        },
      });
    },
    deleteResourceCategory: function(category) {
      return showModal({
        template: require('./deleteResourceCategoryDialog.html'),
        controller: 'DeleteResourceCategoryDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          category: category,
        },
      });
    },
    deleteResource: function(category, resource) {
      return showModal({
        template: require('./deleteResourceDialog.html'),
        controller: 'DeleteResourceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          category: category,
          resource: resource,
        },
      });
    },

    createInvoiceDetailReport: function(relation, filters, batchParams) {
      return showModal({
        template: require('./createRegistrationInvoiceDetailReport.html'),
        controller: 'CreateRegistrationInvoiceDetailReportCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          relation,
          filters,
          batchParams,
        },
      });
    },
  };
}
